class ReviewControl {
  constructor() {
    const dataEl = document.querySelector('#review_control_data');
    if (!dataEl) {
      return;
    }

    const data = JSON.parse(dataEl.textContent);
    const tempData = [];
    data.forEach(item => {
      if (item.author.includes(',')) {
        const items = item.author.split(',');
        const review_texts = item.review_text.split(',');
        items.forEach((author, index) => {
          const review_text = review_texts[index] ? review_texts[index].trim() : '';
          tempData.push({ author: author.trim(), review_text: review_text });
        });
      } else {
        tempData.push({ author: item.author, review_text: item.review_text });
      }
    });
    this.data = tempData;
    console.log('data', this.data);
    this.container = document.querySelector('.shopify-app-section');

    this.totalReviews = this.getTotalReviews();

    if (this.data.length > 0) {
      const shopifyAppSection = document.querySelector('.shopify-app-section');
      if (shopifyAppSection) {
        this.initIntersectionObserver(shopifyAppSection);
      }
    }
  }

  initIntersectionObserver(element) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const reviewList = document.querySelector('.oke-w-reviews-list')
          if(reviewList) {
            this.observeChanges(reviewList);
          }
          this.hideReviews();
          // Once observed, disconnect the intersection observer
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '100px'
    });

    observer.observe(element);
  }

  observeChanges(element) {
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.getTotalReviews();
          this.hideReviews();
        }
      });
    });

    const config = {
      attributes: false,
      childList: true,
      subtree: true,
    };

    this.mutationObserver.observe(element, config);
  }

  getTotalReviews() {
    const reviewsCountElement = document.querySelector('.oke-w-reviews-count');
    if (reviewsCountElement) {
      const countText = reviewsCountElement.textContent.trim();
      const match = countText.match(/\d+/);
      if (match) {
        return parseInt(match[0], 10);
      }
    }
    return 0;
  }

  updateReviewCounts(hiddenCount) {
    if (hiddenCount > 0) {
      const reviewsCountElement = document.querySelector('.oke-w-reviews-count');
      const ratingAverageModuleCountElement = document.querySelector('.oke-w-ratingAverageModule-count');
      const visibleCount = this.totalReviews - hiddenCount;

      if (reviewsCountElement) {
        reviewsCountElement.textContent = `${visibleCount} reviews`;
      }

      if (ratingAverageModuleCountElement) {
        ratingAverageModuleCountElement.textContent = `Based on ${visibleCount} reviews`;
      }
    }

    // Stop the MutationObserver if there is no oke-showMore-button in the DOM
    if (!document.querySelector('.oke-showMore-button') && this.mutationObserver) {
      // this.mutationObserver.disconnect();
      console.log('MutationObserver disconnected due to missing oke-showMore-button');
    }
  }

  hideReviews() {
    const listItems = document.querySelectorAll('.oke-w-reviews-list-item');
    let hiddenCount = 0;

    listItems.forEach(item => {
      const reviewerNameElement = item.querySelector('.oke-w-reviewer-name');
      const reviewContentElement = item.querySelector('.oke-reviewContent-body.oke-bodyText p');
      if (reviewerNameElement && reviewContentElement) {
        const reviewerName = reviewerNameElement.textContent.trim();
        const reviewContent = reviewContentElement.textContent.trim();
        const matchingReviews = this.data.filter(review => review.author === reviewerName);

        if (matchingReviews.length > 0) {
          const shouldHide = matchingReviews.some(review => {
            return review.review_text ? reviewContent.includes(review.review_text) : true;
          });

          if (shouldHide && !item.classList.contains('hidden')) {
            item.classList.add('hidden');
            hiddenCount++;
          }
          if (item.classList.contains('hidden')) {
            hiddenCount++;
          }
        }
      }
    });

    this.updateReviewCounts(hiddenCount);
  }
}

const reviewControl = new ReviewControl();
